module.exports = __webpack_public_path__ + "img/skala-1820.a49b1fe4.png";